"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSavedTheme = void 0;
window.getTheme = function () { return localStorage.getItem('theme'); };
window.setTheme = function (theme) {
    var themePath = "css/theme.".concat(theme, ".css");
    if (!CheckUrl(themePath))
        return;
    var previousElements = document.head.querySelectorAll('[data-theme]');
    var element = document.createElement('link');
    element.dataset.theme = '';
    element.rel = 'stylesheet';
    element.type = 'text/css';
    element.href = themePath;
    element.onload = function () { return previousElements.forEach(function (e) { var _a; return (_a = e.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(e); }); };
    document.head.appendChild(element);
    localStorage.setItem('theme', theme);
};
window.useSavedTheme = useSavedTheme;
function useSavedTheme() {
    var theme = localStorage.getItem('theme');
    if (theme !== 'dark' && theme !== 'light') {
        localStorage.removeItem('theme');
        return;
    }
    window.setTheme(theme !== null ? theme : 'dark');
}
exports.useSavedTheme = useSavedTheme;
function CheckUrl(url) {
    var http;
    if (window.XMLHttpRequest)
        http = new XMLHttpRequest(); // IE7+, Firefox, Chrome, Opera, Safari
    else
        http = new ActiveXObject("Microsoft.XMLHTTP"); // IE6, IE5
    http.open('HEAD', url, false);
    http.send();
    return http.status !== 404;
}
